var exports = {
  "D": "x31de4314--522b0d--dailyrent-price-container",
  "n": "x31de4314--522b0d--dailyrent-price",
};

module.exports = exports;
